import React,{FC} from 'react'
import { createStyles, makeStyles } from "@mui/styles";
import {Grid,Typography,Stepper,Step,StepLabel,useMediaQuery,useTheme, Button} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { useSession } from 'hooks/SessionProvider';
import { steps } from 'utils/constants';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useRoute  } from 'hooks/RouteProvider';
import { customRoutes } from 'utils/constants';

const useStyles = makeStyles((theme:any) =>
    createStyles({
        dialogHeaderMain:{
            // display:"flex",
            // justifyContent:"space-between",
            // alignItems:"center",
            // marginTop:"20px"
        } ,
        dialogTitle:{
            fontSize:"1.2rem !important",
            fontWeight:"600 !important",
            fontFamily: 'Open Sans !important', 
            [theme.breakpoints.down("sm")]:{
                textAlign:"center"
            }
        },
         bussinessTitle:{
            fontSize:"1.5rem !important",
            fontWeight:"600 !important",
            textAlign:"center",
            fontFamily: 'Open Sans !important', 
            color:"#3D5A80"
        },
        backButton:{
            color:"#3D5A80 !important",
            borderRadius:"10px !important",
            borderColor:"#d6d6d6 !important",
            '&:hover': {
            backgroundColor: '#fff !important',
            color:"#3D5A80 !important"
          },
        },
          text: {
            flexGrow: 1,
            textAlign: 'center',
            marginLeft:"10px"
          },
    })
  );
  interface props{
    handleClose?:()=>void;
    BusinessDetails?:any
  }
const DialogHeader:FC<props>=({handleClose,BusinessDetails})=> {
    const classes = useStyles();
    const { activeStep , setIsDateTimeSelected } = useSession();
    const { navigate } = useRoute();
    const getRoute = useRoute();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const onBackPressed=()=>{
    if( getRoute.route == customRoutes.DRDetails) {
            navigate(customRoutes.APTDetails)
        } else {
            navigate(customRoutes.DRDetails)
            setIsDateTimeSelected(false)
        }
    }
  return (
    <Grid className={classes.dialogHeaderMain}>
        <Grid sx={{marginTop:"20px",display:"flex",alignItems:"center",gap:"10px",flexDirection:`${isSmallScreen && "column-reverse"}`}}>
            {getRoute.route == customRoutes.DRDetails || getRoute.route == customRoutes.appointmentForm? <Grid sx={{width:`${!isSmallScreen && "10%"}`}}>
            <Button variant='outlined'  className={classes.backButton} sx={{textTransform: "none",}} onClick={onBackPressed}>
            <ArrowBackIcon/>
           {<span className={classes.text}>Go Back</span>}
            </Button> 
             </Grid> : null
            }

          <Grid sx={{textAlign:"center",width:`${getRoute.route == customRoutes.DRDetails || getRoute.route == customRoutes.appointmentForm ? "79%":"100%"}`}}>
           <Typography variant='h1' className={classes.bussinessTitle}>
             {BusinessDetails?.name}
            </Typography>
          </Grid>
        </Grid>
      { getRoute.route != customRoutes.successAPT && <Grid sx={{paddingTop:"30px"}}>
            <Stepper activeStep={activeStep} nonLinear>
            {steps.map((label) => (
            <Step key={label}>
                <StepLabel>{!isSmallScreen && label}</StepLabel>
            </Step>
            ))}
        </Stepper>
        </Grid>}
        {/* <Grid>
            <Tooltip title={"colse"} onClick={handleClose}>
                <IconButton>
                    <CloseIcon></CloseIcon>
                </IconButton>
            </Tooltip>
        </Grid> */}
    </Grid>
  )
}

export default DialogHeader